module.exports = __webpack_public_path__ + "img/img6.509ee1c1.png";